// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_8ea3013f","outerContainer":"f6b96e46","secondaryToolbar":"ab5df7ac","doorHangerRight":"_98c99761","toolbarContainer":"bcee3077","toolbarViewerMiddle":"_6da9f621","progressBar":"_043035ff","back-to-application":"_23a9ada4","root":"_0376cb08","hideEllipsis":"affa2961","definition":"_2de767c3","root--multiline":"d5fb5c9f","description":"_76a4c72b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DefinitionList/index.styl
// module id = 4945
// module chunks = 39